<template>
  <navigation>
    <router-view />
  </navigation>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* #app被注入后就没有这个元素了 */
body,#app {
 font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 7.5rem;
  height: auto;
  background-color: #fff;
}
#h-picker .area_ctrl{background-color: #fff;}
.swiper-pagination-bullet,.slider-pagination-bullet{color:#999999;opacity: 1;}
.slider-pagination-bullet-active-render,.slider-pagination-bullet-active{opacity: 1;color: #0480E8;}
.slider-pagination{top: 1.22rem;}
.yd-mask{position: absolute !important;}
.yd-popup-center{position: absolute !important;}
.yd-spinner>input{color: #0689F7 !important;font-size: 0.4rem !important;}
.yd-spinner-circle>span{border: 1px solid #ccc;}
.yd-grids-3:before{background-image: none !important;}
/* .yd-cell-left{font-size: 0.32rem !important;color: #000 !important;font-weight: bold !important;} */
#ucenterlist-content .yd-cell-left{font-size: 0.32rem;color: #000;}
#ucenterlist-content .yd-cell{padding: 0 0.1rem;}
#ucenterlist-content .yd-cell-icon {margin-right: 0.15rem;}
</style>



// WEBPACK FOOTER //
// src/App.vue